









export default {
    name: 'BaseSection',
    components: {},
    props: {
        background: {
            type: String(),
            default: 'none',
        },
        space: {
            type: Boolean(),
            default: false,
        },
    },
    computed: {
        color() {
            return String(this.background) === 'none' ? '#F1F1F1' : 'white';
        },
    },
    data() {
        return {};
    },
    methods: {},
};
